<template>
  <DeleteConfirm
      itemKey="Revenue"
      :fetchData="fetchData"
      :setTitle="setTitle"
      :setQuestion="setQuestion"
      :deleteData="deleteData"
      @onDelete="(response) => $emit('onDelete', response)"
      v-bind="$attrs"
  />
</template>

<script>
  import Revenues from '@/services/revenues'

  import DeleteConfirm from '@/components/_Part/_Modal/_Confirm/Delete'

  export default {
    name: 'Delete',
    props: [
      'id'
    ],
    emits: [
      'onDelete'
    ],
    components: {
      DeleteConfirm
    },
    methods: {
      fetchData() {
        return Revenues
          .read({
            id: this.id
          })
      },
      setTitle(Item) {
        return 'Odstrániť príjem "' + Item.title + '"  z ' + this.$moment(Item.paidAt).format('DD.MM.YYYY')
      },
      setQuestion(Item) {
        return 'Naozaj chcete odstrániť príjem "' + Item.title + '"  z ' + this.$moment(Item.paidAt).format('DD.MM.YYYY') + '?'
      },
      deleteData() {
        return Revenues
          .delete({
            id: this.id
          })
      }
    }
  }
</script>
